/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const BuildingIcon = ({ width = 24, height = 24, hidden = false, title = 'Building' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M33 2H5a1 1 0 0 0-1 1v30a1 1 0 0 0 1 1h11V22h6v12h11a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1ZM12 26H6v-4h6Zm0-8H6v-4h6Zm0-8H6V6h6Zm10 8h-6v-4h6Zm0-8h-6V6h6Zm10 16h-6v-4h6Zm0-8h-6v-4h6Zm0-8h-6V6h6Z"
    />
  </svg>`;
};
